export default {
	methods: {
		calculateProgress: function(appl) {
			// APPL레코드 전체에 대한 진도율 산출
			let totalPages = 0, viewedPages = 0, totalLength = 0, totalDuration = 0;
			if(appl.lec.curriculumList && appl.lec.curriculumList.length) {
				appl.lec.curriculumList[0].lesList.forEach((lesMain) => {
					// 이 위치에서 lesMain은 차시에 해당하는 LES레코드임
					lesMain.child.forEach((les) => {
						// 이 위치에서 les는 단원에 해당하는 LES레코드임
						totalPages += parseInt(les.connContPages);
						let tempArr = les.lesProgressList.filter((pgItem) => {
							if(pgItem.mberId==appl.mberId) return true;
							else return false;
						});
						if(tempArr && tempArr.length) {
							viewedPages += parseInt(tempArr[tempArr.length-1].pageNum);
							totalLength += parseInt(tempArr[tempArr.length-1].totalLength);
							tempArr.forEach((el) => {
								if(el.endTime && el.startTime) totalDuration += (parseInt(el.endTime) - parseInt(el.startTime))/1000;
							})
						}
					})
				});
			} else {
				appl.progress = 0;
			}
			if(viewedPages > totalPages) viewedPages = totalPages;
			if(totalLength==0) {
				appl.progress = Math.round((viewedPages/totalPages)*100*10) / 10;
				if(!appl.progress) appl.progress = 0;
			} else {
				appl.progress = totalDuration ? Math.round(((totalDuration * (viewedPages/totalPages)) / totalLength) * 100 * 10) / 10 : 0;
			}
			if(appl.progress > 100) appl.progress = 100;

			// 차시에 대한 진도율 산출
			if(appl.lec.curriculumList && appl.lec.curriculumList.length) {
				appl.lec.curriculumList[0].lesList.forEach((lesMain) => {
					let totalPages2 = 0, viewedPages2 = 0, totalLength2 = 0, totalDuration2 = 0;
					// 이 위치에서 lesMain은 차시에 해당하는 LES레코드임
					lesMain.child.forEach((les) => {
						totalPages2 += parseInt(les.connContPages);
						// 이 위치에서 les는 단원에 해당하는 LES레코드임
						les.lesProgressList.forEach(() => {
							let tempArr = les.lesProgressList.filter((pgItem) => {
								if(pgItem.mberId==appl.mberId) return true;
								else return false;
							});
							if(tempArr && tempArr.length) {
								// 이 위치에서 mem은 이 단원을 한번이라도 열람했던 회원의 LES_PROGRESS레코드임
								viewedPages2 += parseInt(tempArr[tempArr.length-1].pageNum);
								totalLength2 += parseInt(tempArr[tempArr.length-1].totalLength);
								tempArr.forEach((el) => {
									if(el.endTime && el.startTime) totalDuration2 += (parseInt(el.endTime) - parseInt(el.startTime))/1000;
								})
							}
						})
					})
					if(viewedPages2 > totalPages2) viewedPages2 = totalPages2;
					if(totalLength2==0) {
						lesMain.progress = Math.round((viewedPages2/totalPages2)*100*10) / 10;
						if(!lesMain.progress) lesMain.progress = 0;
					} else {
						lesMain.progress = totalDuration2 ? Math.round(((totalDuration2 * (viewedPages2/totalPages2)) / totalLength2) * 100 * 10) / 10 : 0;
					}
					if(lesMain.progress > 100) lesMain.progress = 100;
				});
			}

			// 단원에 대한 진도율 산출
			if(appl.lec.curriculumList && appl.lec.curriculumList.length) {
				appl.lec.curriculumList[0].lesList.forEach((lesMain) => {
					// 이 위치에서 lesMain은 차시에 해당하는 LES레코드임
					lesMain.child.forEach((les) => {
						let totalPages3 = les.connContPages, viewedPages3 = 0, totalLength3 = 0, totalDuration3 = 0;
						// 이 위치에서 les는 단원에 해당하는 LES레코드임
						les.lesProgressList.forEach(() => {
							let tempArr = les.lesProgressList.filter((pgItem) => {
								if(pgItem.mberId==appl.mberId) return true;
								else return false;
							});
							if(tempArr && tempArr.length) {
								// 이 위치에서 mem은 이 단원을 한번이라도 열람했던 회원의 LES_PROGRESS레코드임
								viewedPages3 += parseInt(tempArr[tempArr.length-1].pageNum);
								totalLength3 += parseInt(tempArr[tempArr.length-1].totalLength);
								tempArr.forEach((el) => {
									if(el.endTime && el.startTime) totalDuration3 += (parseInt(el.endTime) - parseInt(el.startTime))/1000;
								})
							}
						})
						if(viewedPages3 > totalPages3) viewedPages3 = totalPages3;
						if(totalLength3==0) {
							les.progress = Math.round((viewedPages3/totalPages3)*100*10) / 10;
							if(!les.progress) les.progress = 0;
						} else {
							les.progress = totalDuration3 ? Math.round(((totalDuration3 * (viewedPages3/totalPages3)) / totalLength3) * 100 * 10) / 10 : 0;
						}
						if(les.progress > 100) les.progress = 100;
					})
				});
			}





			/*
			// appl객체에 대한 progress산출
			if(obj.applId) {
				let applTotal = 0, applCurrent = 0;
				obj.progress = 0;
				obj.lec.curriculumList.forEach(curriculum => {
					let curriculumTotal = 0, curriculumCurrent = 0;
					curriculum.progress = 0;
					curriculum.lesList.forEach(lesGrp => {
						let lesGrpTotal = 0, lesGrpCurrent = 0;
						lesGrp.progress = 0;
						lesGrp.child.forEach(les => {
							let lesTotal = les.connContPages?parseInt(les.connContPages):0, lesCurrent = 0;
							les.progress = 0;
							les.lesProgressList.forEach(lp => {
								// 동영상콘텐츠에 대한 진도율
								if(lp.startTime && lp.endTime && lp.playStartTime && lp.playEndTime && lp.totalLength) {
									// 재생시간을 초단위로 환산
									let startTimeInSec = 0, endTimeInSec = 0;
									lp.playStartTime.split(":").forEach((num,idx) => {
										if(idx==0) startTimeInSec += parseInt(num)*60*60;
										if(idx==1) startTimeInSec += parseInt(num)*60;
										if(idx==2) startTimeInSec += parseInt(num);
									})
									lp.playEndTime.split(":").forEach((num,idx) => {
										if(idx==0) endTimeInSec += parseInt(num)*60*60;
										if(idx==1) endTimeInSec += parseInt(num)*60;
										if(idx==2) endTimeInSec += parseInt(num);
									})
									// 재생시간이 영상길이의 90% 이상인지 확인
									if(endTimeInSec-startTimeInSec > lp.totalLength*0.9) {
										lesCurrent += 1;
									}
								}
								// 텍스트콘텐츠/플래시콘텐츠에 대한 진도율
								if(lp.startTime && lp.endTime) {
									lesCurrent += 1;
								}
							});
							if(lesTotal)
								les.progress = parseInt((lesCurrent / lesTotal) * 100);
							lesGrpTotal += lesTotal;
							lesGrpCurrent += lesCurrent;
						})
						if(lesGrpTotal)
							lesGrp.progress = parseInt((lesGrpCurrent / lesGrpTotal) * 100);
						curriculumTotal += lesGrpTotal;
						curriculumCurrent += lesGrpCurrent;
					})
					if(curriculumTotal)
						curriculum.progress = parseInt((curriculumCurrent / curriculumTotal) * 100);
					applTotal += curriculumTotal;
					applCurrent += curriculumCurrent;
				});
				if(applTotal)
					obj.progress = parseInt((applCurrent / applTotal) * 100);
			}
			// curriculum객체에 대한 progress산출
			else if(obj.curriculumId) {
				let curriculumTotal = 0, curriculumCurrent = 0;
				obj.progress = 0;
				obj.lesList.forEach(lesGrp => {
					let lesGrpTotal = 0, lesGrpCurrent = 0;
					lesGrp.progress = 0;
					lesGrp.child.forEach(les => {
						let lesTotal = les.connContPages?parseInt(les.connContPages):0, lesCurrent = 0;
						les.progress = 0;
						les.lesProgressList.forEach(lp => {
							// 동영상콘텐츠에 대한 진도율
							if(lp.startTime && lp.endTime && lp.playStartTime && lp.playEndTime && lp.totalLength) {
								// 재생시간을 초단위로 환산
								let startTimeInSec = 0, endTimeInSec = 0;
								lp.playStartTime.split(":").forEach((num,idx) => {
									if(idx==0) startTimeInSec += parseInt(num)*60*60;
									if(idx==1) startTimeInSec += parseInt(num)*60;
									if(idx==2) startTimeInSec += parseInt(num);
								})
								lp.playEndTime.split(":").forEach((num,idx) => {
									if(idx==0) endTimeInSec += parseInt(num)*60*60;
									if(idx==1) endTimeInSec += parseInt(num)*60;
									if(idx==2) endTimeInSec += parseInt(num);
								})
								// 재생시간이 영상길이의 90% 이상인지 확인
								if(endTimeInSec-startTimeInSec > lp.totalLength*0.9) {
									lesCurrent += 1;
								}
							}
							// 텍스트콘텐츠/플래시콘텐츠에 대한 진도율
							if(lp.startTime && lp.endTime) {
								lesCurrent += 1;
							}
						});
						if(lesTotal)
							les.progress = parseInt((lesCurrent / lesTotal) * 100);
						lesGrpTotal += lesTotal;
						lesGrpCurrent += lesCurrent;
					})
					if(lesGrpTotal)
						lesGrp.progress = parseInt((lesGrpCurrent / lesGrpTotal) * 100);
					curriculumTotal += lesGrpTotal;
					curriculumCurrent += lesGrpCurrent;
				})
				if(curriculumTotal)
					obj.progress = parseInt((curriculumCurrent / curriculumTotal) * 100);
			}
			// lesGrp(=차시)에 대한 progress산출
			else if(obj.lesId && obj.child.length) {
				let lesGrpTotal = 0, lesGrpCurrent = 0;
				obj.progress = 0;
				obj.child.forEach(les => {
					let lesTotal = les.connContPages?parseInt(les.connContPages):0, lesCurrent = 0;
					les.progress = 0;
					les.lesProgressList.forEach(lp => {
						// 동영상콘텐츠에 대한 진도율
						if(lp.startTime && lp.endTime && lp.playStartTime && lp.playEndTime && lp.totalLength) {
							// 재생시간을 초단위로 환산
							let startTimeInSec = 0, endTimeInSec = 0;
							lp.playStartTime.split(":").forEach((num,idx) => {
								if(idx==0) startTimeInSec += parseInt(num)*60*60;
								if(idx==1) startTimeInSec += parseInt(num)*60;
								if(idx==2) startTimeInSec += parseInt(num);
							})
							lp.playEndTime.split(":").forEach((num,idx) => {
								if(idx==0) endTimeInSec += parseInt(num)*60*60;
								if(idx==1) endTimeInSec += parseInt(num)*60;
								if(idx==2) endTimeInSec += parseInt(num);
							})
							// 재생시간이 영상길이의 90% 이상인지 확인
							if(endTimeInSec-startTimeInSec > lp.totalLength*0.9) {
								lesCurrent += 1;
							}
						}
						// 텍스트콘텐츠/플래시콘텐츠에 대한 진도율
						if(lp.startTime && lp.endTime) {
							lesCurrent += 1;
						}
					});
					if(lesTotal)
						les.progress = parseInt((lesCurrent / lesTotal) * 100);
					lesGrpTotal += lesTotal;
					lesGrpCurrent += lesCurrent;
				})
				if(lesGrpTotal)
					obj.progress = parseInt((lesGrpCurrent / lesGrpTotal) * 100);
			}
			// les(=단원)에 대한 progress산출
			else if(obj.lesId) {
				let lesTotal = obj.connContPages?parseInt(obj.connContPages):0, lesCurrent = 0;
				obj.lesProgressList.forEach(lp => {
					// 동영상콘텐츠에 대한 진도율
					if(lp.startTime && lp.endTime && lp.playStartTime && lp.playEndTime && lp.totalLength) {
						// 재생시간을 초단위로 환산
						let startTimeInSec = 0, endTimeInSec = 0;
						lp.playStartTime.split(":").forEach((num,idx) => {
							if(idx==0) startTimeInSec += parseInt(num)*60*60;
							if(idx==1) startTimeInSec += parseInt(num)*60;
							if(idx==2) startTimeInSec += parseInt(num);
						})
						lp.playEndTime.split(":").forEach((num,idx) => {
							if(idx==0) endTimeInSec += parseInt(num)*60*60;
							if(idx==1) endTimeInSec += parseInt(num)*60;
							if(idx==2) endTimeInSec += parseInt(num);
						})
						// 재생시간이 영상길이의 90% 이상인지 확인
						if(endTimeInSec-startTimeInSec > lp.totalLength*0.9) {
							lesCurrent += 1;
						}
					}
					// 텍스트콘텐츠/플래시콘텐츠에 대한 진도율
					if(lp.startTime && lp.endTime) {
						lesCurrent += 1;
					}
				});
				if(lesTotal)
					obj.progress = parseInt((lesCurrent / lesTotal) * 100);
			}
			*/
		}
	}
}